"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var I8N_1 = require("./I8N");
exports.langKeyMap = {
    ar: ["ar", "Ar", "arabicName", "ArabicName", "nameAr", "NameAr"],
    en: ["en", "En", "englishName", "EnglishName", "nameEn", "NameEn"],
};
var langKeys = ["ar", "en"];
function getLocalValue(lv, forceLocale) {
    return Select(lv, forceLocale);
}
exports.getLocalValue = getLocalValue;
function Select(subject, selector) {
    if (subject) {
        if (typeof subject !== "object")
            return subject;
        else {
            var sub = subject;
            var key_1 = selector == null ? I8N_1.default.locale() : selector;
            var langMap = exports.langKeyMap[key_1];
            if (langMap == null) {
                key_1 = "en";
                langMap = exports.langKeyMap[key_1];
            }
            var probableKeys = langKeys.filter(function (x) { return x !== key_1; });
            for (var _i = 0, langMap_1 = langMap; _i < langMap_1.length; _i++) {
                var k = langMap_1[_i];
                if (sub.hasOwnProperty(k)) {
                    var value = sub[k];
                    if (value != undefined)
                        return value;
                }
            }
            for (var _a = 0, probableKeys_1 = probableKeys; _a < probableKeys_1.length; _a++) {
                var k = probableKeys_1[_a];
                langMap = exports.langKeyMap[k];
                for (var _b = 0, langMap_2 = langMap; _b < langMap_2.length; _b++) {
                    var lk = langMap_2[_b];
                    if (sub.hasOwnProperty(lk)) {
                        var value = sub[lk];
                        if (value != undefined)
                            return value;
                    }
                }
            }
        }
    }
    return null;
}
exports.Select = Select;
//# sourceMappingURL=LocaleValue.js.map